import { isEmpty, defaultTo } from 'lodash';
import { getWeblabs } from '../../shared/selectors/bootstrapData';

let data;

class BootstrapData {
  static load() {
    if (!data) {
      const dataElement = document.getElementById('__data__');
      if (dataElement !== null) {
        data = JSON.parse(dataElement.innerHTML);
      }
    }
    return data;
  }

  constructor(bootstrapData) {
    // @TODO AUTHOR-6808 - how do we handle missing values?

    const defaultData = {
      account: {
        customerId: '',
      },
      csrftoken: {
        token: '',
      },
    };

    this.data = {
      ...bootstrapData,
      account: defaultTo(bootstrapData.account, defaultData.account),
      csrftoken: defaultTo(bootstrapData.csrftoken, defaultData.csrftoken),
    };
  }

  getI18n() {
    if (isEmpty(this.data.i18n)) return { strings: {} };

    const { locale } = this.data.i18n[0];
    const localeStrings = this.data.i18n
      .filter(({ locale: assetLocale }) => assetLocale === locale)
      .map(({ data: { strings } }) => strings)
      .reduce((accumulator, currentValue) => ({ ...accumulator, ...currentValue }), {});
    return {
      locale,
      strings: localeStrings,
    };
  }

  getState() {
    return {
      csrfToken: defaultTo(this.data.csrftoken.token, ''),
      customerId: defaultTo(this.data.account.customerId, ''),
      i18n: this.getI18n(),
      domain: this.data.domain,
      weblabs: getWeblabs(this.data),
    };
  }
}

export default BootstrapData;
